const CONTROL_VARIANT = 0;

export const TESTS = {
    SLP_PROPERTY_REVIEWS: 'HA_PTA_SLP_PropertyReviewsIteration2',
    QUICK_SERP_FILTERS: 'HA_PTA_LANDING_QuickSeRPFiltersV2',
    SLP_PROPERTY_TYPE_PRICES: 'HA_PTA_SLP_FromPricesPropertyTypesCarouselV2',
    GDPR: 'ha_gdpr_banner',
    LISTING_CARD_IMAGES: 'HA_PTA_LANDING_ListingCardImages',
    REDESIGN_QA_SEO_TEXT: 'HA_PTA_LANDING_RedesignQASEOText',
    POLYFILL_SERVICE: 'HA_PTA_LANDING_PolyfillService',
    LOW_LEVEL_GEO_TEMPLATE: 'HA_PTA_LANDING_LowLevelGeoSLPTemplate',
    HIGH_LEVEL_GEO_TEMPLATE: 'HA_PTA_LANDING_HighLevelGeoSLPTemplate',
    PINNED_SERP_SEARCH_MODAL: 'HA_PTA_MLP_PinnedSeRPSearchModal',
    PROPERTY_TYPE_NAME_LISTING_CARDS: 'HA_PTA_LANDING_PropertyTypeNameListingCards',
    STREAM_LANDING: 'HA_PTA_SLP_StreamLanding',
    DEFAULT_SEARCHBOX_DATES: 'HA_PTA_LANDING_DefaultSearchboxDates',
    RECOMMENDED_PROPERTIES: 'HA_PTA_LANDING_RecommendedPropertiesSLP',
    ORIGIN_CORRIDOR_DESTINATIONS: 'HA_PTA_LANDING_SLPOriginCorridorDestinations',
    DISCOVERY_PROPERTY_FEED: 'HA_PTA_LANDING_DiscoveryfeedSLPs',
    PRE_BRAND_TRANSITION: 'HA_GX_PRE_BRAND_TRANSITION',
    POST_BRAND_TRANSITION: 'HA_GX_POST_BRAND_TRANSITION',
    DISCOVERY_DESTINATIONS: 'HA_PTA_LANDING_DestinationDiscoveryfeedSLPs',
    CAROUSEL_PAGE_SIZE: 'HA_PTA_LANDING_CarouselPageSize',
    PROPERTY_TITLE_IN_LISTING_CARD: 'HA_PTA_LANDING_PropertyTitleInListingCard',
    DESTINATION_RECOMMENDATIONS: 'HA_PTA_LANDING_SimilarDestinationsonSLPs'
};

export const EVALUATE = [
    TESTS.SLP_PROPERTY_REVIEWS,
    TESTS.QUICK_SERP_FILTERS,
    TESTS.SLP_PROPERTY_TYPE_PRICES,
    TESTS.GDPR,
    TESTS.LISTING_CARD_IMAGES,
    TESTS.REDESIGN_QA_SEO_TEXT,
    TESTS.POLYFILL_SERVICE,
    TESTS.LOW_LEVEL_GEO_TEMPLATE,
    TESTS.HIGH_LEVEL_GEO_TEMPLATE,
    TESTS.PINNED_SERP_SEARCH_MODAL,
    TESTS.PROPERTY_TYPE_NAME_LISTING_CARDS,
    TESTS.STREAM_LANDING,
    TESTS.DEFAULT_SEARCHBOX_DATES,
    TESTS.RECOMMENDED_PROPERTIES,
    TESTS.ORIGIN_CORRIDOR_DESTINATIONS,
    TESTS.DISCOVERY_PROPERTY_FEED,
    TESTS.PRE_BRAND_TRANSITION,
    TESTS.POST_BRAND_TRANSITION,
    TESTS.DISCOVERY_DESTINATIONS,
    TESTS.CAROUSEL_PAGE_SIZE,
    TESTS.PROPERTY_TITLE_IN_LISTING_CARD,
    TESTS.DESTINATION_RECOMMENDATIONS
];

export const hasTest = (abacus, test) => !!(abacus && abacus[test]);

/**
 * @returns {number} The test variant number the user was bucketed into, or the
 *   control variant (0) if the test wasn't found.
 */
export const getValue = (abacus, test) =>
    hasTest(abacus, test) ?
        abacus[test].value :
        CONTROL_VARIANT;
